import { useState } from 'react';

const useValidateFields = (amount) => {
  const [errors, setErrors] = useState<{
    amount?: string;
  }>({});

  const validate = (field: string, targetValue: string) => {
    const errs: {
      amount?: string;
    } = {};

    switch (field) {
      case 'amount':
        if (Number(targetValue) > Number(amount)) {
          errs.amount = 'Exceeds pool limit';
        }
        if (targetValue === '') {
          errs.amount = 'Value will not be empty';
        }
        if (targetValue && Number(targetValue) === 0) {
          errs.amount = 'Value will be not zero';
        }
        break;
    }
    setErrors(errs);
  };

  return { errors, setErrors, validate };
};

export default useValidateFields;
